interface Props {
    firstAndLastLetter: string;
    greeting: string;
    userName: string;
    formattedDate: string;
}

export default function AccountHeader({ firstAndLastLetter, greeting, userName, formattedDate, }: Props) {
    return (
        <div className="flex flex-shrink-0 items-center gap-3 overflow-hidden rounded-t-xl bg-[#186cb2] px-3 py-3 shadow-sm sm:px-4 sm:py-3.5">
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-white text-xs font-bold uppercase text-[#186cb2] shadow-sm sm:h-11 sm:w-11">
                {firstAndLastLetter}
            </div>
            <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                    <p className="truncate text-sm font-semibold text-white">
                        {`${greeting}, ${userName}!`}
                    </p>
                    <span className="hidden h-1 w-1 rounded-full bg-blue-200 sm:block" />
                    <p className="text-[10px] font-medium text-blue-100 sm:text-[11px]">
                        {formattedDate}
                    </p>
                </div>
                <p className="mt-0.5 truncate text-[10px] font-medium text-blue-100 sm:text-xs">
                    Manage your account information and security settings.
                </p>
            </div>
        </div>
    );
}